module.exports = __webpack_public_path__ + "static/img/6153_phase_function_Paper_PointsHejduk_Prediction.bed09db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6153_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 94+/
// module chunks = 0